import { Session } from "@/models/Session";
import { MutationTree } from "vuex";
import { AccountState } from ".";
import { LoginResult } from "@/models/LoginResult";

export enum AccountMutations {
    SetSession = "setSession",
    SetLoginResult = "setLoginResult",
    SetErrors = "setErrors",
    SetLoading = "setLoading"
}

const mutations: MutationTree<AccountState> = {
    [AccountMutations.SetSession](state, payload: Session): void {
        state.session = payload;
    },
    [AccountMutations.SetLoginResult](
        state,
        payload: LoginResult | null
    ): void {
        state.loginResult = payload;
    },
    [AccountMutations.SetErrors](state, payload: string[] | null): void {
        state.errors = payload;
    },
    [AccountMutations.SetLoading](state, payload: boolean): void {
        state.loading = payload;
    }
};

export default mutations;
